// @core/api/endpoints/workflow/update_test_case.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestCaseResponse,
  UpdateTestCaseRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update test case
 * Updates test case trigger data, mocks, or assertions.
 */
export async function UpdateTestCase(
  test_case_id: string,
  data: UpdateTestCaseRequest,
  options?: RequestOptions
): Promise<TestCaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/test-cases/:test_case_id`;
  requestPath = requestPath.replace(':test_case_id', encodeURIComponent(test_case_id));
  const requestOptions = options;
  return client.put<TestCaseResponse>(requestPath, data, requestOptions);
}
